<style src="./style.scss">
</style>

<script lang="ts">
  import Button from "@components/button";
  import Checkbox from "@components/checkbox";
  import DangerZone from "@components/dangerZone";

  export let options;
  export let remainingDays;
  export let nextPaymentRemainingDays;
  export let goBack = () => null;
  export let unsubscribe = () => null;
</script>

<div>
  <h1>Cancelar a assinatura</h1>
  <DangerZone
    title="Ao cancelar, declaro estar ciente de que após o período de vigência da minha assinatura já contratada:"
    bind:options />

  <div class="unsubscribe__buttons">
    <div>
      <Button title="Manter minha assinatura" onClick="{goBack}" />
        <div>
          <span>
            Você tem <b>{nextPaymentRemainingDays} dias restantes</b> para aproveitar seus benefícios
            no CNA Go até a próxima cobrança.
          </span>
        </div>
    </div>
    <div>
      <Button
        title="Cancelar agora"
        type="secondary"
        onClick="{unsubscribe}"
        disabled="{options.some((option) => !option.checked)}" />
      <div>
        <span>
          <a target="_blank" href="https://cnago.app/termos/"
            >Contrato e Termos de uso CNA Go</a>
        </span>
      </div>
    </div>
  </div>
</div>
